import { OrderRequestForm } from './order-request-form';

interface RequestPageProps {
    menuItems: App.Data.MenuItemData[];
    categories: Array<string>;
    customer?: App.Data.CustomerData | null;
}

const RequestPage = ({ menuItems, categories, customer }: RequestPageProps) => {
    return (
        <section className="container mx-auto max-w-3xl px-4 py-12">
            <OrderRequestForm
                menuItems={menuItems}
                categories={categories}
                customer={customer}
            />
        </section>
    );
};

export default RequestPage;
